import Fade from '@mui/material/Fade';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { useMediaQuery, useTheme } from '@mui/system';

// Local imports
import FormLink from './FormLink';

export const pillStyles = {
    px: '0.7rem',
    py: '0.5rem',
    borderRadius: '20px',
    width: { xs: '100%', sm: '80%' },
    minWidth: 'fit-content',
    maxWidth: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    ml: {
        xs: 0,
        sm: '0.3rem',
    },
    my: '0.5rem',
    color: 'rgb(104, 76, 150)',
    fontWeight: '600',
}

const iconStyles = {
    verticalAlign: 'middle',
    mx: '0.3rem',
    fontSize: {
        xs: 'medium',
        sm: 'large',
    }
}

const linkStyles = {
    fontWeight: '600', 
    textDecoration: 'none',
    fontSize: {
        xs: '0.8rem',
        sm: '0.9rem',
        md: '1rem'
    },
    wordBreak: 'break-all'
}

const REDCAP_FORM_LINK = process.env.REACT_APP_REDCAP_FORM_LINK || 'https://redcap.nubic.northwestern.edu/redcap/surveys/?s=RM8EWDCNDDHFXYJL';

const constructLink = (href, text) => {
    return `<a href=${href} style='color: #ffffff; font-weight: 600;'>${text}</a>`;
}

const CardComponent = ({ pageTitle }) => {
    const [paragraph, setParagraph] = useState('');
    const { t, i18n } = useTranslation();
    const currentLng = i18n.language;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isContactPage = pageTitle === 'contact';

    useEffect(() => {
        setParagraph(t(`${pageTitle}.paragraph`));
        
        let p = t(`${pageTitle}.paragraph`);

        // Add a link to Eligibility guidelines in Homepage
        const eligibilityEn = "eligibility guidelines";
        if (p.includes(eligibilityEn)) {
            const eligibilityLink = constructLink('/#eligibility', eligibilityEn);
            p = p.replace(eligibilityEn, eligibilityLink);
        }

        const eligibilityVi = "điều kiện tham gia";
        if (p.includes(eligibilityVi)) {
            const eligibilityLink = constructLink('/#eligibility', eligibilityVi);
            p = p.replace(eligibilityVi, eligibilityLink);
        }

        // Add link to FAQ section in Participate page
        const faqEn = "FAQ section";
        if (p.includes(faqEn)) {
            const faqLink = constructLink('/faq', faqEn);
            p = p.replace(faqEn, faqLink);
        }
        
        const faqVi = "các câu hỏi thường gặp";
        if (p.includes(faqVi)) {
            const faqLink = constructLink('/faq', faqVi);
            p = p.replace(faqVi, faqLink);
        }

        setParagraph(p);
    }, [currentLng])

    return (
        <Fade in timeout={1000}>
            <div className='main'>
                <Box sx={{ 
                    background: 'linear-gradient(0.25turn, rgb(91, 59, 140), rgb(118, 93, 160), rgb(118, 093, 160))',
                    color: '#fff',
                    width: {
                        xs: '100%',
                        sm: '80%',
                        md: '60%',
                    },
                    maxWidth: '35rem',
                    minHeight: '25rem',
                    margin: '0 auto',
                    padding: '2rem',
                    borderRadius: '15px',
                    }}>
                    <Typography variant={isMobile ? 'h6' : 'h4'} sx={{ textAlign: 'center', mb: {xs: 1, sm: 2, md: '2rem'} }}>{t(`${pageTitle}.title`)}</Typography>
                    <Box>
                        <Typography variant='subtitle1' sx={{ lineHeight: '2', display: 'inline' }} dangerouslySetInnerHTML={{__html: paragraph}} />
                        {isContactPage && <Typography variant='subtitle1' sx={{ display: 'inline'}}>{t('contact.email_text')}</Typography>}
                        
                        {/* REDCap form link */}
                        {!isContactPage && t(`${pageTitle}.form_text`) && <FormLink 
                            link={REDCAP_FORM_LINK} 
                            text={t(`${pageTitle}.form_text`)}
                            />}
                        
                        {!isContactPage && <Typography variant='subtitle1'>{t('contact.email_text')}</Typography>}
                        <Box sx={pillStyles}>
                            <Link href={`mailto:${t('contact.email')}`} sx={linkStyles}> 
                                <EmailIcon sx={iconStyles} /> 
                                {t('contact.email')}
                            </Link>
                        </Box>
                        {t('contact.call_text')}
                        <Box sx={pillStyles}>
                            <Link href={`tel:${t('contact.phone')}`} sx={linkStyles}>
                                <LocalPhoneIcon sx={iconStyles} />
                                {t('contact.phone')}
                            </Link>
                        </Box>
                    </Box>
                </Box>
            </div>
        </Fade>
    )
}

export default CardComponent;